import * as React from "react";
import './confirmation-step.scss';
import {useLeadStore} from "../store/Lead.store";

export const ConfirmationStep = () => {

    const store = useLeadStore();

    return <div>
        <div className="row">
            <div className="col-md-4 offset-md-4 mt-4">
                <div className="card confirmation-card">
                    <div className="card-body">
                        <p className="mt-2 preline">{store.configuration.appointmentMessage}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
};
